"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var VideoCameraDisabled = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M6.84355718,4.13660584 L6.9032025,4.20431817 L17.9032025,19.2043182 C18.0665031,19.4270008 18.0183644,19.7399019 17.7956818,19.9032025 C17.7214543,19.957636 17.6372025,19.9885763 17.5518086,19.9973898 L17.4663629,19.9988784 C17.3528051,19.9911639 17.2424803,19.9449228 17.1564428,19.8633942 L17.0967975,19.7956818 L6.0967975,4.79568183 C5.93349694,4.57299924 5.98163558,4.26009807 6.20431817,4.0967975 C6.2785457,4.04236398 6.36279752,4.0114237 6.44819143,4.00261018 L6.53363707,4.00112163 C6.64719493,4.00883605 6.75751966,4.05507715 6.84355718,4.13660584 Z M6.473,6.99912163 L7.206,7.99912163 L6,7.99996634 C5.4865,7.99996634 5.06439796,8.38542347 5.00671757,8.88324672 L5,9 L5,16 C5,16.5135 5.38542347,16.935602 5.88324672,16.9932824 L6,17 L13.806,16.9991216 L14.4949979,17.9381891 C14.3916457,17.9645348 14.2850849,17.9828243 14.1760246,17.9923485 L14,18 L6,18 C4.94618182,18 4.0818843,17.1836033 4.00548911,16.1491916 L4,16 L4,9 C4,7.94618182 4.81639669,7.0818843 5.85080841,7.00548911 L6,7 L6.473,6.99912163 Z M10.192,6.99912163 L14,7 C15.0538182,7 15.9181157,7.81639669 15.9945109,8.85080841 L16,9 L16,10 L20,8 L20,17 L16.094,15.0461216 L15,13.5551216 L15,13.5 L19,15.382 L19,9.618 L15,11.5 L15,9 C15,8.4865 14.6145765,8.06439796 14.1167533,8.00671757 L14,7.99996634 L10.926,7.99912163 L10.192,6.99912163 Z M9.406,10.9991216 L8,11 C7.75466667,11 7.55041975,10.8230123 7.50806036,10.5898381 L7.5,10.5 C7.5,10.2546667 7.67698765,10.0504198 7.91016187,10.0080604 L8,10 L8.673,9.99912163 L9.406,10.9991216 Z" })));
};
VideoCameraDisabled.displayName = 'VideoCameraDisabled';
exports.default = VideoCameraDisabled;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=VideoCameraDisabled.js.map